var moduleMap = {
	"./recoil": () => {
		return Promise.all([__webpack_require__.e(73), __webpack_require__.e(257)]).then(() => (() => ((__webpack_require__(9257)))));
	},
	"./services": () => {
		return Promise.all([__webpack_require__.e(580), __webpack_require__.e(447), __webpack_require__.e(386), __webpack_require__.e(88), __webpack_require__.e(555), __webpack_require__.e(582)]).then(() => (() => ((__webpack_require__(2582)))));
	},
	"./en/translation": () => {
		return __webpack_require__.e(646).then(() => (() => ((__webpack_require__(2447)))));
	},
	"./ms/translation": () => {
		return __webpack_require__.e(164).then(() => (() => ((__webpack_require__(5164)))));
	},
	"./user-list-page": () => {
		return Promise.all([__webpack_require__.e(580), __webpack_require__.e(447), __webpack_require__.e(386), __webpack_require__.e(578), __webpack_require__.e(398), __webpack_require__.e(501), __webpack_require__.e(335), __webpack_require__.e(927), __webpack_require__.e(819), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(555), __webpack_require__.e(949), __webpack_require__.e(131), __webpack_require__.e(108)]).then(() => (() => ((__webpack_require__(7108)))));
	},
	"./user-create-page": () => {
		return Promise.all([__webpack_require__.e(580), __webpack_require__.e(447), __webpack_require__.e(386), __webpack_require__.e(398), __webpack_require__.e(176), __webpack_require__.e(927), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(555), __webpack_require__.e(949), __webpack_require__.e(131), __webpack_require__.e(163), __webpack_require__.e(180)]).then(() => (() => ((__webpack_require__(2754)))));
	},
	"./user-edit-page": () => {
		return Promise.all([__webpack_require__.e(580), __webpack_require__.e(447), __webpack_require__.e(386), __webpack_require__.e(578), __webpack_require__.e(398), __webpack_require__.e(176), __webpack_require__.e(501), __webpack_require__.e(596), __webpack_require__.e(927), __webpack_require__.e(819), __webpack_require__.e(73), __webpack_require__.e(88), __webpack_require__.e(555), __webpack_require__.e(949), __webpack_require__.e(131), __webpack_require__.e(163), __webpack_require__.e(92)]).then(() => (() => ((__webpack_require__(8092)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});